import { ErrorUtil } from '@/utils/Error'

export const ErrorHelper = {
  ...ErrorUtil,

  jumpToError (el, execute = false, query = '.card--invalid') {
    if (execute) {
      window.setTimeout(() => {
        el.querySelector(query)?.scrollIntoView({
          behavior: 'smooth'
        })
      }, 500)
    }
  }
}
